import { isSidepanelHost } from "@/client/utils/getAppEnvironment";
import type { TelemetrySurface } from "@/shared/telemetry.api";

/**
 * Which product surface is hosting the page: the plain website, the Sounds
 * plugin's Creative Partner sidepanel, or the Splice Labs plugin. Strictly
 * more specific than DisplayMode (compact == either plugin surface).
 */
export const getHostSurface = (): TelemetrySurface => {
    if (typeof window === "undefined" || window.parent === window) {
        return "web";
    }
    return isSidepanelHost() ? "creative-partner" : "labs-plugin";
};
